import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../auth/api";
import { alertSuccess, alertError } from "../components/Alert";

// Define the base URL
const BASE_URL = "/access/panel";

// Async thunks for fetching data
export const fetchAppCategory = createAsyncThunk(
  "accessManager/fetchAppCategory",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE_URL}/AppCategory`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchAppSubCategory = createAsyncThunk(
  "accessManager/fetchAppSubCategory",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE_URL}/AppSubCategory`);
      console.log(response.data)
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchAppGroup = createAsyncThunk(
  "accessManager/fetchAppGroup",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE_URL}/AppGroup`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchAppConnection = createAsyncThunk(
  "accessManager/fetchAppConnection",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE_URL}/AppConnection`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchEndPoint = createAsyncThunk(
  "accessManager/fetchEndPoint",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE_URL}/EndPoint`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const fetchProjectEndPoint = createAsyncThunk(
  "accessManager/fetchProjectEndPoint",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE_URL}/ProjectEndPoint`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);


export const fetchProjectSetting = createAsyncThunk(
  "accessManager/fetchProjectSetting",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE_URL}/ProjectSetting`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchProjectRequest = createAsyncThunk(
  "accessManager/fetchProjectRequest",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE_URL}/ProjectRequest`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchSecurityEvent = createAsyncThunk(
  "accessManager/fetchSecurityEvent",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE_URL}/SecurityEvent`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchAccessSection = createAsyncThunk(
  "accessManager/fetchAccessSection",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE_URL}/Section`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchAccessSectionMap = createAsyncThunk(
  "accessManager/fetchAccessSectionMap",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE_URL}/Section/Map`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchAccessSectionField = createAsyncThunk(
  "accessManager/fetchAccessSectionField",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE_URL}/Section/Field`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Async thunks for patching data
export const patchAppCategory = createAsyncThunk(
  "accessManager/patchAppCategory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.patch(`${BASE_URL}/AppCategory`, payload);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

export const patchAppSubCategory = createAsyncThunk(
  "accessManager/patchAppSubCategory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.patch(`${BASE_URL}/AppSubCategory`, payload);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

export const patchAppGroup = createAsyncThunk(
  "accessManager/patchAppGroup",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.patch(`${BASE_URL}/AppGroup`, payload);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

export const patchAppConnection = createAsyncThunk(
  "accessManager/patchAppConnection",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.patch(`${BASE_URL}/AppConnection`, payload);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

export const patchEndPoint = createAsyncThunk(
  "accessManager/patchEndPoint",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.patch(`${BASE_URL}/EndPoint`, payload);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

export const patchProjectEndPoint = createAsyncThunk(
  "accessManager/patchProjectEndPoint",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.patch(`${BASE_URL}/ProjectEndPoint`, payload);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Initial state
const initialState = {
  appCategory: null,
  appSubCategory: null,
  appGroup: null,
  appConnection: null,
  endPoint: null,
  projectEndPoint: null,
  projectSetting: null,
  projectRequest: null,
  securityEvent: null,
  accessSection: null,
  accessSectionMap: null,
  accessSectionField: null,
  status: "idle",
  error: null,
};

// Slice
const accessManagerSlice = createSlice({
  name: "accessManager",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Fetch fulfilled
    builder
      .addCase(fetchAppCategory.fulfilled, (state, action) => {
        state.appCategory = action.payload;
        state.status = "succeeded";
      })
      .addCase(fetchAppSubCategory.fulfilled, (state, action) => {
        state.appSubCategory = action.payload;
        state.status = "succeeded";
      })
      .addCase(fetchAppGroup.fulfilled, (state, action) => {
        state.appGroup = action.payload;
        state.status = "succeeded";
      })
      .addCase(fetchAppConnection.fulfilled, (state, action) => {
        state.appConnection = action.payload;
        state.status = "succeeded";
      })
      .addCase(fetchEndPoint.fulfilled, (state, action) => {
        state.endPoint = action.payload;
        state.status = "succeeded";
      })
      .addCase(fetchProjectEndPoint.fulfilled, (state, action) => {
        state.projectEndPoint = action.payload;
        state.status = "succeeded";
      })
      .addCase(fetchProjectSetting.fulfilled, (state, action) => {
        state.projectSetting = action.payload;
        state.status = "succeeded";
      })
      .addCase(fetchProjectRequest.fulfilled, (state, action) => {
        state.projectRequest = action.payload;
        state.status = "succeeded";
      })
      .addCase(fetchSecurityEvent.fulfilled, (state, action) => {
        state.securityEvent = action.payload;
        state.status = "succeeded";
      })
      .addCase(fetchAccessSection.fulfilled, (state, action) => {
        state.accessSection = action.payload;
        state.status = "succeeded";
      })
      .addCase(fetchAccessSectionMap.fulfilled, (state, action) => {
        state.accessSectionMap = action.payload;
        state.status = "succeeded";
      })
      .addCase(fetchAccessSectionField.fulfilled, (state, action) => {
        state.accessSectionField = action.payload;
        state.status = "succeeded";
      });

    // Patch fulfilled
    builder
      .addCase(patchAppCategory.fulfilled, (state, action) => {
        state.appCategory = action.payload;
        state.status = "succeeded";
      })
      .addCase(patchAppSubCategory.fulfilled, (state, action) => {
        state.appSubCategory = action.payload;
        state.status = "succeeded";
      })
      .addCase(patchAppGroup.fulfilled, (state, action) => {
        state.appGroup = action.payload;
        state.status = "succeeded";
      })
      .addCase(patchAppConnection.fulfilled, (state, action) => {
        state.appConnection = action.payload;
        state.status = "succeeded";
      })
      .addCase(patchEndPoint.fulfilled, (state, action) => {
        state.endPoint = action.payload;
        state.status = "succeeded";
      })
      .addCase(patchProjectEndPoint.fulfilled, (state, action) => {
        state.projectEndPoint = action.payload;
        state.status = "succeeded";
      });

    // Pending (optional for loading state)
    builder
      .addMatcher(
        (action) => action.type.endsWith("/pending"),
        (state) => {
          state.status = "loading";
          state.error = null;
        }
      );

    // Rejected (optional for error state)
    builder
      .addMatcher(
        (action) => action.type.endsWith("/rejected"),
        (state, action) => {
          state.status = "failed";
          state.error = action.payload;
        }
      );
  },
});

export default accessManagerSlice.reducer;
